
import React from "react";
import Navbar from "@/components/Navbar";
import EventForm from "@/components/EventForm";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const AddEvent = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow container py-8">
        <Button 
          variant="ghost" 
          className="mb-6 flex items-center gap-2"
          onClick={() => navigate("/events")}
        >
          <ArrowLeft size={16} />
          Back to Events
        </Button>
        
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">Add New Event</h1>
          <p className="text-muted-foreground mb-8">
            Share your eco-friendly event with the community
          </p>
          
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <EventForm />
          </div>
        </div>
      </main>
      
      <footer className="bg-gray-100 py-6">
        <div className="container text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Ourcelium. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default AddEvent;
